import {ComponentHelper, FormBaseComponent, ValidationPattern, ValidatorService} from '@utils-lib';
import {Component, OnInit} from '@angular/core';
import {AppNameEnum, HandelsregisterBezeichnungEnumLabels, handelsregisterBezeichnungToTranslationKey, Konzern} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';


const MAX_LENGTH_NAME = 200;
const MAX_LENGTH_HANDELSREGISTER_NUMMER = 11;

@Component({
    selector: 'common-ui-konzern',
    templateUrl: './konzern.component.html'
})
export class KonzernComponent extends FormBaseComponent<Konzern> implements OnInit {

    public handelsregisterBezeichnungEnum = HandelsregisterBezeichnungEnumLabels;
    public toTranslationKey = handelsregisterBezeichnungToTranslationKey;
    public showKonzern = false;
    public showAmtsgericht = true;
    public showAuslandFields = false;
    public konzernSwitchTranslation = '';

    constructor(private readonly formBuilder: FormBuilder,
                private readonly validatorService: ValidatorService,
                protected readonly messageService: DatevMessageService,
                protected readonly activatedRoute: ActivatedRoute,
                private readonly translateService: TranslateService) {
        super(messageService);
    }

    ngOnInit(): void {
        super.ngOnInit();
        if (this.data?.isGesellschaftKonzernzugehoerig) {
            this.showKonzern = true;
        }
        const formular = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);
        this.konzernSwitchTranslation = this.translateService.instant(`COMMON_UI.FRAGEBOGEN.KONZERN.GEHOERT_ZU_KONZERN_SWITCH_${formular.toUpperCase()}`);
        if (formular === AppNameEnum.FragebogenKapGAus) {
            this.showAmtsgericht = false;
            this.showAuslandFields = true;
        }
    }

    onShowKonzernChanged(checked: boolean): void {
        if (checked) {
            this.data = {isGesellschaftKonzernzugehoerig: true};
        } else {
            this.data = {};
        }
    }

    protected createForm(): void {
        // Legacy-Wert 'GR' aus altem Datenbestand im Backend bereinigen,
        // um Validierungsfehler beim Zurücksenden zu vermeiden.
        if ((this.data.handelsregisterBezeichnung as string) === 'GR') {
            this.data.handelsregisterBezeichnung = null;
        }
        this.form = this.formBuilder.group({
            isGesellschaftKonzernzugehoerig: this.data.isGesellschaftKonzernzugehoerig,
            nameKonzern: [this.data.nameKonzern, [
                this.validatorService.maxLength(MAX_LENGTH_NAME),
                this.validatorService.required()
            ]],
            handelsregisterBezeichnung: [this.data.handelsregisterBezeichnung, []],
            handelsregisterNummer: [this.data.handelsregisterNummer, [
                this.validatorService.maxLength(MAX_LENGTH_HANDELSREGISTER_NUMMER)
            ]],
            amtsgericht: [this.data.amtsgericht, [
                this.validatorService.maxLength(200)
            ]],
            auslHrg: [this.data.auslHrg, [
                this.validatorService.maxLength(128)
            ]],
            auslHrgNr: [this.data.auslHrgNr, [
                this.validatorService.maxLength(128)
            ]],
            inlHrg: [this.data.inlHrg, [
                this.validatorService.maxLength(128)
            ]],
            wirtschaftsIdNummer: [this.data.wirtschaftsIdNummer, [
                this.validatorService.pattern(ValidationPattern.WIRTSCHAFTS_ID,
                    this.translateService.instant('COMMON_UI.VALIDATION.WIRTSCHAFTS_ID_NUMMER_INVALID_PATTERN'))
            ]]
        });
    }
}
